import { useState } from 'react';
import { makeLogoUrl } from '../models/makeLogoModel';

// Failure belongs to this URL only. A refreshed version is immediately visible.
export function useMakeLogo(value) {
  const primary = makeLogoUrl(value), fallback = makeLogoUrl(value?.logo?.png_url);
  const [failed, setFailed] = useState([]);
  const url = [primary, fallback].find(candidate => candidate && !failed.includes(candidate)) || null;
  return { url, fail: () => setFailed(previous => previous.includes(url) ? previous : [...previous, url]) };
}
